import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";

const SAHSStudentshub=()=>{
return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="School of Pharmaceutical Sciences" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Student Hub at MVN University" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>SportsExcellence:</b><br />
        Wide range of indoor and outdoor sports facilities, regular tournaments, and inter-university championships to promote physical fitness and teamwork.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
<b>Music Club:</b>
<br/>
A vibrant platform for budding musicians to showcase their talents through live performances, band formations and musical workshops.
<br/><br/>
<b>Dance Crew:</b>
<br/>
Opportunities to train in various dance forms like classical to contemporary and perform at university and national-level events.
<br/><br/>
<b>Cultural Events:</b>
<br/>
Annual cultural festivals, talent shows, and celebrations of national and international days that bring together creativity, diversity and spirit.
<br/><br/>
<b>Art & Drama Society:</b>
<br/>
Engage in theatrical productions, street plays, fine arts exhibitions, and creative writing competitions.
Active student-run clubs and societies that encourage leadership, innovation and community service.
<br/><br/>
<b>Adventure and Outdoor Activities:</b><br />
Exciting activities like trekking, adventure camps and educational tours for overall student development.
<br /><br/>
<b>Workshops, Seminars and Conferences:</b>
<br />
<p>Regularly organized expert talks, workshops and personal development programs to enhance learning beyond academics.</p>
    <br /><br />
    <b>Social Responsibility Initiatives:</b>
    <br />
    Student participation in blood donation camps, field visits, health checkup camps, awareness camps, environment drives and other social service projects fostering a sense of responsibility and empathy.
    </Typography>
    <br />
    </Grid>
    </Grid>

)
}
export default SAHSStudentshub;